module.exports = "<section *ngIf=\"appIsReady; else app_not_ready\" >\n  <div class='routeContainer' [@routeAnimation] =\"getDepth(o)\">\n    <router-outlet #o=\"outlet\"></router-outlet>\n  </div>\n</section>\n\n<ng-template #app_not_ready>\n\t<div class=\"hollowLoader\">\n\t  <div class=\"largeBox\"></div>\n\t  <div class=\"smallBox\"></div>\n\t</div>\n</ng-template>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main